import React, {Component} from "react";
import {Button} from "primereact/button";
import {Growl} from 'primereact/growl';
import {PTT_ROL, REG_EXP_EMAIL} from "../../../../utils/constants/Constants";
import {SendAvailableDetailService} from "../../../../service/operation/availableValuesPTM/SendAvailableDetailService";
import SendAvailableDetailView from "./SendAvailableDetailView";
import ConfirmationMessage from "../../../../components/confirmationMessage"
import {CatalogService} from "../../../../service/catalog/CatalogService";
import {Check, Clear} from "@material-ui/icons";

export default class SendAvailableDetailContainer extends Component {
    constructor(props) {
        super(props);
        this.sendAvailableDetailService = new SendAvailableDetailService();
        this.catalogService = new CatalogService();
        this.getDataInstitutionDetail = this.getDataInstitutionDetail.bind(this);
        this.pageTable = React.createRef();
        this.pageTableEm = React.createRef();
        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.state = {
            dataInstitutionDetail: this.getDataInstitutionDetail(),
            dataInstitutionSend: [],
            selectedInstitutions: [],
            emailStr: "",
            isLoading: true,
        };

        this.sendEmails = this.sendEmails.bind(this);
        this.send = this.send.bind(this);
        this.openSendEmail = this.openSendEmail.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.onSelectionChangeTable = this.onSelectionChangeTable.bind(this);
        this.onChangeTextDialog = this.onChangeTextDialog.bind(this);
        this.loading = this.loading.bind(this);
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    formatStatus(rowData) {
        let icon0 = <div><Clear color={"error"}/></div>;
        let icon1 = <div><Check color={"secondary"}/></div>;
        return (rowData['statusCarga'] === 0  ? icon0 : icon1);
    }

    getDataInstitutionDetail() {
        this.loading(true);
        this.sendAvailableDetailService.getInstitutionAvailablePTM()
            .then(resp => {
                this.setState({
                    dataInstitutionDetail: resp.payload,
                });
                this.pageTable.current.setState({first: 0,});
                this.loading(false);
            });
    }

    openSendEmail() {
        this.loading(true);
        this.catalogService.getCatalogInstitutionByRol(PTT_ROL)
            .then(resp => {
                this.setState({
                    dataInstitutionSend: resp,
                    selectedInstitutions: [],
                    emailStr: "",
                    displayDialog: true,
                });
                this.pageTableEm.current.setState({first: 0,});
                this.loading(false);
            });
    }

    validEmailStr(emailArray) {
        let result = true;
        emailArray.forEach(email => {
            if (!REG_EXP_EMAIL.test(email.trim())) {
                result = false;
                return true;
            }
        });
        return result;
    }

    sendEmails() {
        if (this.state.selectedInstitutions.length === 0) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'Favor de seleccionar al menos un registro.'
            });
        } else {
            let isValidEmailStr = this.state.emailStr !== "" ?
                this.validEmailStr(this.state.emailStr.split(",")) : true;
            if (isValidEmailStr) {
                this.confirmationRef.openConfirmationMessage();
            } else {
                this.growl.show({
                    severity: 'error', summary: 'Error.',
                    detail: 'Correos ocultos no válidos.'
                });
            }
        }
    }

    send() {
        let institutionsToSend = [];
        this.state.selectedInstitutions.forEach(institution => {
            institutionsToSend.push({
                id: institution['idInstitucion'].toString(),
                descripcionId: institution['nombreCorto'],
            });
        });

        this.sendAvailableDetailService.sendMailAvailablePTM(
            institutionsToSend, this.state.emailStr)
            .then(resp => {
                if (resp.message === "Success") {
                    this.growl.show({
                        severity: 'success', summary: 'Éxito.',
                        detail: 'Los correos se han enviado exitosamente'
                    });
                } else if (resp.error !== '') {
                    let msg = resp.error.replace(/<br\/>/g, ', ');
                    msg = msg.substring(0, msg.length - 2);
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: msg,
                    });
                }
                this.onHideDialog();
            });
    }

    openConfirmationMessage() {
        if (this.confirmationRef) {
            this.confirmationRef.openConfirmationMessage();
        }
    }

    onHideDialog() {
        this.setState({displayDialog: false});
    }

    onChangeTextDialog(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    onSelectionChangeTable(event) {
        this.setState({selectedInstitutions: event.value,})
    }

    render() {
        let dialogHeader =
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                    <h2 className={"secondary-text"}>Operación \ Valores Disponibles PTM \ Enviar Detalle</h2>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Regresar" onClick={this.onHideDialog}
                            className="p-button-secondary"/>
                </div>
                <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                    <Button label="Enviar" onClick={this.sendEmails}/>
                </div>
            </div>;
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Está seguro de enviar los correos de Disponibilidad del Prestamista?"
                                           action={this.send}/>;

        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        const {
            dataInstitutionDetail, displayDialog, isLoading,
            dataInstitutionSend, selectedInstitutions, emailStr
        } = this.state;

        return <SendAvailableDetailView
            dataInstitutionDetail={dataInstitutionDetail}
            dataInstitutionSend={dataInstitutionSend}
            selectedInstitutions={selectedInstitutions}
            emailStr={emailStr}
            dialogHeader={dialogHeader}
            displayDialog={displayDialog}
            isLoading={isLoading}
            messagesGrowl={messagesGrowl}
            confMsg={confMsg}
            pageTable={this.pageTable}
            pageTableEm={this.pageTableEm}
            openSendEmail={this.openSendEmail}
            getDataInstitutionDetail={this.getDataInstitutionDetail}
            onSelectionChangeTable={this.onSelectionChangeTable}
            onHideDialog={this.onHideDialog}
            onChangeTextDialog={this.onChangeTextDialog}
            formatStatus={this.formatStatus}
        />
    }
};